// extracted by mini-css-extract-plugin
export default {"shadowed":"BaseLayout_shadowed__cnab+","dark":"BaseLayout_dark__OhWqN","light":"BaseLayout_light__VM05t"};